import { useMemo } from 'react';
import { encode } from 'uqr';

export interface QrCodeProps {
  /** QR コードにする文字列（例：otpauth://totp/...） */
  value: string;
  /** 表示サイズ（px） */
  size?: number;
  /** 読み上げ用の説明 */
  label?: string;
}

/**
 * QR コード（SVG）。ブラウザ内で生成し、値を外部に送信しない（2段階認証の秘密鍵を含むため）。
 * 誤り訂正レベル M、余白 4 モジュール（読み取りやすさ優先）。
 */
export function QrCode({ value, size = 200, label = 'QR コード' }: QrCodeProps) {
  const { path, dim } = useMemo(() => {
    const qr = encode(value, { ecc: 'M', border: 4 });
    let d = '';
    qr.data.forEach((row, y) =>
      row.forEach((on, x) => {
        if (on) d += `M${x} ${y}h1v1h-1z`;
      }),
    );
    return { path: d, dim: qr.size };
  }, [value]);
  return (
    <svg
      className="bs-qrcode"
      role="img"
      aria-label={label}
      width={size}
      height={size}
      viewBox={`0 0 ${dim} ${dim}`}
      shapeRendering="crispEdges"
      data-qr-value-length={value.length}
    >
      <rect width={dim} height={dim} fill="#fff" />
      <path d={path} fill="#071826" />
    </svg>
  );
}
